import $ from 'jquery';
import dailyOffersTimerTemplate from './template';

function mountTimers() {
  $('[data-daily-offer-timer]').each(function () {
    const $node = $(this);

    if ($node.data('mounted')) return;

    const variant = $node.data('timer-variant');

    $node.html(dailyOffersTimerTemplate({ variant }));
    $node.data('mounted', true);

    const timerEnd = $node.data('timer-end');
    if (timerEnd) {
      const $timer = $node.find('.daily-offer-timer');
      initTimer($timer, new Date(timerEnd));
      $timer.data('timer-initialized', true);
      $timer.removeClass('hidden');
      $timer.siblings('.daily-offers-timer-skeleton').remove();
    }
  });
}

function initTimer($timer, nextOfferAt) {
  function updateTimer() {
    const now = new Date();
    const timeRemaining = nextOfferAt - now;

    if (timeRemaining <= 0) {
      $timer.find('.daily-offer-timer-title').text('Акция завершена');
      $timer.find('.timer-hours').text('00');
      $timer.find('.timer-minutes').text('00');
      $timer.find('.timer-seconds').text('00');
      return;
    }

    const days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
    const hours = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));

    $timer.find('.timer-hours').text(days.toString().padStart(2, '0'));
    $timer.find('.timer-minutes').text(hours.toString().padStart(2, '0'));
    $timer.find('.timer-seconds').text(minutes.toString().padStart(2, '0'));
  }

  updateTimer();
  setInterval(updateTimer, 1000);
}

function initTimersWithData(nextOfferAt) {
  $('.daily-offer-timer').each(function () {
    const $timer = $(this);

    if ($timer.data('timer-initialized')) return;

    initTimer($timer, nextOfferAt);
    $timer.data('timer-initialized', true);

    $timer.removeClass('hidden');
    $timer.siblings('.daily-offers-timer-skeleton').remove();
  });
}

$(document).ready(function () {
  const observer = new MutationObserver(() => {
    mountTimers();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  mountTimers();

  if ($('[data-daily-offer-timer]:not([data-timer-end])').length > 0) {
    $.get('/next_daily_offer_time', function (data) {
      const nextOfferAt = new Date(data.next_daily_offer_at);

      initTimersWithData(nextOfferAt);

      const dataObserver = new MutationObserver(() => {
        initTimersWithData(nextOfferAt);
      });

      dataObserver.observe(document.body, {
        childList: true,
        subtree: true,
      });
    });
  }
});
